'use client'

import { type Locale, translate } from '@shared/config/i18n'
import { openConfirmDialog } from '@shared/ui'
import React from 'react'

import { Button, ConfirmDialogV1Title, Typography } from '@podo-app/design-system-temp'

export const openUnblockConfirmDialog = ({
  tutorName,
  onConfirm,
  locale = 'ko',
}: {
  tutorName: string
  onConfirm: () => void
  locale?: Locale
}) => {
  const t = (key: string, values?: Record<string, string | number>) => translate(locale, key, values)

  openConfirmDialog({
    ConfirmHeader: () => (
      <ConfirmDialogV1Title>
        <Typography size="h3" className="font-bold text-center">
          {t('tutorExclusion.dialog.unblockTitle', { tutorName })}
        </Typography>
      </ConfirmDialogV1Title>
    ),
    ConfirmFooter: ({ handleClose }) => (
      <React.Fragment>
        <Button variant="ghost" size="xLarge" fullWidth onClick={handleClose} data-testid="btn-unblock-cancel">
          {t('common.actions.cancel')}
        </Button>
        <Button
          variant="primary"
          size="xLarge"
          fullWidth
          onClick={() => {
            onConfirm()
            handleClose()
          }}
          data-testid="btn-unblock-confirm"
        >
          {t('tutorExclusion.dialog.unblockConfirm')}
        </Button>
      </React.Fragment>
    ),
  })
}
